// extracted by mini-css-extract-plugin
module.exports = {"root":"Attention_root__5_kl6","attention":"Attention_attention__JwKLJ","reduced-attention":"Attention_reduced-attention__49K4m"};